import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export default function RenameModal({ close, renameList, data }) {
  const [name, setName] = useState("");

  useEffect(() => {
    setName(data.name);
  }, []);
  return (
    <>
      <Modal isOpen={true} toggle={close}>
        <ModalHeader toggle={close}>Rename List</ModalHeader>
        <ModalBody>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter design name"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                renameList(data.id, name, data.isNew);
                setTimeout(() => {
                  close();
                }, 500);
              }
            }}
            autoFocus
          />
          <div className="modal-actions">
            <button className="btn btn-secondary" type="button" onClick={close}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                renameList(data.id, name, data.isNew);
                setTimeout(() => {
                  close();
                }, 500);
              }}
            >
              Rename
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
